<template>
  <div>
    <div class="rj-page-card">
      <!-- <div class="rj-page-card__title">电汇查询</div> -->
      <div class="rj-page-card__content">
        <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
          <el-form-item label="实际付款人名称:" prop="drawee">
            <el-input v-model="searchForm.drawee" placeholder="请输入实际付款人名称" />
          </el-form-item>
          <el-form-item label="付款用途:" prop="remittanceScenario">
            <el-select v-model="searchForm.remittanceScenario" placeholder="请选择" clearable>
              <el-option v-for="option in remittanceScenarioList" :key="option.name" :label="option.name" :value="option.code" />
            </el-select>
          </el-form-item>
          <el-form-item label="付款方式:" prop="remittanceWay">
            <el-select v-model="searchForm.remittanceWay" placeholder="请选择" clearable>
              <el-option v-for="option in remittanceWayList" :key="option.name" :label="option.name" :value="option.code" />
            </el-select>
          </el-form-item>
          <el-form-item label="币种:" prop="currencyName">
            <el-select v-model="searchForm.currencyName" placeholder="请选择">
              <el-option label="美元" value="美元" />
              <el-option label="马币" value="马币" />
              <el-option label="日元" value="日元" />
              <el-option label="人民币" value="人民币" />
            </el-select>
          </el-form-item>
          <el-form-item label="收款单号:" prop="telegraphicTransferNum">
            <el-input v-model="searchForm.telegraphicTransferNum" placeholder="请输入资管收款单号" />
          </el-form-item>
          <el-form-item label="是否委托付款:" prop="entrustedFlg">
            <el-select v-model="searchForm.entrustedFlg" placeholder="请选择">
              <el-option label="否" value="0" />
              <el-option label="是" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item label="付款日期:" prop="remittanceStartTime">
            <div class="rj-flex">
              <div class="rj-flex__item">
                <el-date-picker
                  v-model="searchForm.remittanceStartTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  clearable
                />
              </div>
              <div style="display: inline-block;width: 10px;text-align: center">
                -
              </div>
              <div class="rj-flex__item">
                <el-date-picker
                  v-model="searchForm.remittanceEndTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  clearable
                />
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="isLoading" @click="doSearch">
              搜索
            </el-button>
            <el-button type="default" @click="resetForm('searchForm')">
              重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-loading="isTableLoading" class="tableBody">
      <div style="margin-bottom: 10px">
        <el-button type="primary" @click="messageInput()">
          汇款信息录入
        </el-button>
        <el-button type="primary" :loading="isSubmitLoading" @click="exportExcel">
          汇款信息导出
        </el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData" border style="width: 100%">
        <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
        <el-table-column prop="telegraphicTransferNo" label="汇款编号" align="left" fixed="left">
          <template v-slot="{row}">
            <el-button type="text" @click="openBase(row)">
              {{ row.telegraphicTransferNo }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="remittanceAmount" label="汇款金额" align="right" header-align="left" />
        <el-table-column prop="currencyName" label="币种" align="left" />
        <el-table-column prop="remittanceTime" label="汇款日期" align="left" />
        <el-table-column prop="importCompany" label="实际汇款人名称" align="left" />
        <el-table-column prop="importAccount" label="汇入账户" align="left" />
        <el-table-column prop="strRemittanceScenario" label="汇款用途" align="left" />
        <el-table-column prop="strRemittanceType" label="汇款类型" align="left" />
        <el-table-column prop="strRemittanceWay" label="支付方式" align="left" />
        <el-table-column prop="telegraphicTransferNum" label="收款单号" align="left">
          <template v-slot="{row}">
            <span v-if="row.telegraphicTransferNum === ''">-</span>
            <span v-else>{{ row.telegraphicTransferNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="actualRemittanceAmount" label="实际到款金额" align="right" header-align="left">
          <template v-slot="{row}">
            <span v-if="row.actualRemittanceAmount === ''">-</span>
            <span v-else>{{ row.actualRemittanceAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="entrustedFlg" label="是否委托付款" align="left">
          <template v-slot="{row}">
            <span v-if="row.entrustedFlg === ''">-</span>
            <span v-if="row.entrustedFlg === 1">是</span>
            <span v-if="row.entrustedFlg === 0">否</span>
          </template>
        </el-table-column>
        <el-table-column prop="remittanceState" label="状态" align="left">
          <template v-slot="{row}">
            <span v-if="row.remittanceState ===0">待客户确认</span>
            <span v-if="row.remittanceState ===1">待确认到账</span>
            <span v-if="row.remittanceState ===2">待核查到账</span>
            <span v-if="row.remittanceState ===3">一般户到账 </span>
            <span v-if="row.remittanceState ===4">未收到LC</span>
            <span v-if="row.remittanceState ===5">收到LC正本</span>
            <span v-if="row.remittanceState ===6">确认到账</span>
            <span v-if="row.remittanceState ===-1">已废弃</span>
          </template>
        </el-table-column>
        <el-table-column prop="cz" label="操作" min-width="110" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" @click="open(row)">
              查看
            </el-button>
            <el-button v-if="row.remittanceState === 0" type="text" @click="Abandon(row)">
              废弃
            </el-button>
            <el-button v-if="row.remittanceState === 0" type="text" @click="edit(row)">
              编辑
            </el-button>
            <el-button v-if="row.remittanceState!== -1 && row.remittanceState!== 0" type="text" @click="recall(row)">
              召回
            </el-button>
            <el-button v-if="row.remittanceState === 1 && row.telegraphicTransferNum === ''" type="text" @click="bulu(row)">
              补录收款单号
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="水单查看及下载" :visible.sync="dialogVisible" width="700px" @close="close">
      <el-table ref="multipleTable" :data="fileList" border style="width: 100%">
        <el-table-column prop="fileName" label="文件名称" align="left" fixed="left" />
        <el-table-column prop="createBy" label="上传人" align="left" />
        <el-table-column prop="createTime" label="上传时间" align="left" />
        <el-table-column label="操作" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" @click="download(row)">
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 查看收款单 -->
    <viewRecording
      :visible.sync="dialogVisibleBase"
      :info="info"
      :file-list="fileListBase"
      :table-data="tableDataBase"
      @close="closeBase"
      @downLoadFile="download"
    />
    <!-- 补录收款单 -->
    <receiptRecording
      :visible.sync="dialogVisibleBaseone"
      :row-id="currentReceiptRowId"
      :iswei="iswei"
      :token="token"
      :down-file-url="downFileUrl"
      @close="closeBaseone"
      @success="handleReceiptRecordingSuccess"
    />
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
    <messageInput :message-input-dialog="messageInputDialog" :is-edit="isEdit" :row-data="rowData" :iswei="iswei" @on-status-dialog="updataDialog" />
  </div>
</template>

<script>
import { getlistWaterOrderAttachment, listWaterOrderAttachment, financeExportTelegraphicTransfer, listTelegraphicTransferInternationBusiness, recallTelegraphicTransferForm, abandonTelegraphicTransferForm, getAliOSSDownloadInfo } from '@/API/international.js';
import messageInput from './components/messageInput.vue';
import receiptRecording from './components/receiptRecording.vue';
import viewRecording from './components/viewRecording.vue';
import { attachmentGetToken } from '@/API';
import { downloadBlobFile } from '@/libs/util';
export default {
  data () {
    return {
      Currency1: '',
      Receiptnumber: '',
      Whethertodelegatepayment: '',
      searchForm: {
        drawee: '',
        // paymentAccount: '',
        remittanceStartTime: '',
        remittanceEndTime: '',
        remittanceScenario: '',
        remittanceWay: '',
        currencyName: '', // 币种
        telegraphicTransferNum: '', // 收款单号
        entrustedFlg: '' // 是否委托
      },
      info: {},
      isEdit: false,
      rowData: {},
      page: {
        pageSize: 10,
        total: 100,
        currentPage: 1
      },
      uploadUrl: '',
      downFileUrl: '',
      token: '',
      fileserveDownUrl: '',
      remittanceWayList: [
        {
          name: 'TT',
          code: 1
        },
        {
          name: 'LC',
          code: 2
        },
        {
          name: '其他',
          code: 3
        }
      ],
      remittanceScenarioList: [
        {
          name: '货款',
          code: 1
        },
        {
          name: '服务费',
          code: 2
        },
        {
          name: 'license',
          code: 3
        }
      ],
      businessNameList: [],
      isLoading: false,
      isSubmitLoading: false,
      isTableLoading: false,
      tableData: [],
      messageInputDialog: false,
      dialogVisible: false,
      dialogVisibleBase: false,
      dialogVisibleBaseone: false,
      currentReceiptRowId: '',
      fileList: [],
      fileListBase: [],
      tableDataBase: [],
      iswei: null
    };
  },
  components: {
    messageInput,
    receiptRecording,
    viewRecording
  },
  mounted () {
    this.doSearch();
    this.initToken();
  },
  methods: {
    initToken () {
      attachmentGetToken().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.remittanceEndTime = '';
      this.doSearch();
    },
    doSearch () {
      listTelegraphicTransferInternationBusiness({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.isTableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        };
        // console.log(json.data);
      }).catch(() => {
        this.isTableLoading = false;
      });
    },
    exportExcel () {
      this.isSubmitLoading = true;
      financeExportTelegraphicTransfer(this.searchForm).then((res) => {
        this.isSubmitLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileName = '汇款信息  ' + new Date().toLocaleString() + '.xlsx';
        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {
        this.isSubmitLoading = false;
      });
    },
    messageInput () {
      this.iswei = 0;
      console.log(this.iswei);
      this.isEdit = false;
      this.rowData = {};
      this.messageInputDialog = true;
    },
    edit (row) {
      this.iswei = 1;
      console.log(this.iswei);
      this.isEdit = true;
      this.rowData = row;
      this.messageInputDialog = true;
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.page.currentPage = val;
      this.doSearch();
    },
    // 废弃
    Abandon (row) {
      this.$confirm('你确定要废弃当前来款吗？', '', {
        confirmButtonText: '废弃',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        abandonTelegraphicTransferForm(row.id).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$message({
              type: 'success',
              message: '废弃成功!'
            });
            this.doSearch();
          }
        }).catch((err) => {
          console.log(err);
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    download (row) {
      if (row.fileUrl) {
        window.location.href = row.fileUrl;
        return;
      }
      // 阿里云下载
      if (row.cloudAddress === '1') {
        getAliOSSDownloadInfo(row.fileToken).then(({ status, data }) => {
          if (status === 200) {
            downloadBlobFile({ content: data, fileName: row.fileName });
          }
        });
      } else {
        this.fileserveDownUrl = this.downFileUrl + `/${row.fileToken}?Token=${this.token}`;
        this.$nextTick(() => {
          this.$refs.downTag.click();
        });
      }
    },
    // 召回
    recall (row) {
      this.$confirm('是否召回当前汇款吗?', '', {
        confirmButtonText: '召回',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        recallTelegraphicTransferForm(row.id).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$message({
              type: 'success',
              message: '召回成功!'
            });
            this.doSearch();
          }
        }).catch((err) => {
          console.log(err);
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    updataDialog (val) {
      this.messageInputDialog = val;
      this.doSearch();
    },
    close () {
      this.dialogVisible = false;
      this.fileList = [];
    },
    open (row) {
      this.dialogVisible = true;
      getlistWaterOrderAttachment(row.id).then((res) => {
        const json = res.data;
        if (json.status === '200') {
        //   alert(json.data);
          this.fileList = json.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    openBase (row) {
      this.dialogVisibleBase = true;
      listWaterOrderAttachment(row.id).then((res) => {
        const json = res.data;
        console.log(json);
        if (json.status === '200') {
          const detailInfo = this.formatViewRecordingDetail(json.data);
          this.info = detailInfo;
          this.fileListBase = detailInfo.attachmentList || [];
          this.tableDataBase = detailInfo.intelContractAssignList || [];
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    formatViewRecordingDetail (data) {
      return {
        ...data,
        exchangeRateDate: data.exchangeRateDate ? data.exchangeRateDate.split(' ')[0] : ''
      };
    },
    bulu (row) {
      this.iswei = 0;
      console.log(this.iswei);
      this.currentReceiptRowId = row.id;
      this.dialogVisibleBaseone = true;
    },
    closeBase () {
      this.dialogVisibleBase = false;
      this.info = {};
      this.fileListBase = [];
      this.tableDataBase = [];
    },
    closeBaseone () {
      this.dialogVisibleBaseone = false;
      this.currentReceiptRowId = '';
    },
    handleReceiptRecordingSuccess () {
      this.dialogVisibleBaseone = false;
      this.currentReceiptRowId = '';
      this.doSearch();
    }
  }

};
</script>

<style scoped>
.footer-btn{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
